import { InjectionToken } from "@angular/core";
import { IAppSearchService } from "./app-search.service";

export const APP_SEARCH_SERVICE_TOKEN = new InjectionToken<IAppSearchService>('App search service interface token');
